import {Action} from '@ngrx/store';
import {EnclosureCard} from '../../../models/enclosure-card';
import {Group} from '../../../models/group';

export class UpdateEnclosureCardAction implements Action {
  public static readonly type = 'UpdateEnclosureCardAction';

  constructor(public group: Group, public enclosureCard: EnclosureCard) {
  }

  public type = UpdateEnclosureCardAction.type;
}
